import { defineStore } from 'pinia'
import { ref } from 'vue'
import router from '../router'
import axios from 'axios'

//console.log('auth document.location.host: ' + document.location.host)

//const baseUrl = `${import.meta.env.VITE_API_URL}/users`;

let apachePassword = '560285' //12345678

let baseUrl = `https://vngx01.ivn1.ru/aa/hs/defect-detection-service/auth`
//let baseUrl = `https://aa6.bazis-motors.ru/aa/hs/defect-detection-service/auth`

const axiosConfig = {
  auth: {
    username: 'НеженецИИ', // apache
    password: apachePassword
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const useAuthStore = defineStore('auth', () => {
  
  let returnUrl = ref('')
  const user = ref(JSON.parse(localStorage.getItem('user')))
  const token = ref(JSON.parse(localStorage.getItem('token')))
  const refreshToken = ref(JSON.parse(localStorage.getItem('refreshToken')))

  async function login(user, password) {
    try {
      const resp = await axios.post(
        `${baseUrl}/login`,
        { username: user, password: password },
        { ...axiosConfig, timeout: 15000 } // важно: таймаут
      )

      if (resp.data?.error === null) {
        this.user = user
        this.token = resp.data.accessToken
        this.refreshToken = resp.data.refreshToken

        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('token', JSON.stringify(resp.data.accessToken))
        localStorage.setItem('refreshToken', JSON.stringify(resp.data.refreshToken))

        router.push(this.returnUrl || '/')
        return { ok: true }
      }

      // сервер ответил, но сказал "ошибка"
      return { ok: false, message: resp.data?.error || 'Ошибка авторизации' }
    } catch (err) {
      // сеть / CORS / SSL / timeout / 5xx / 4xx
      const status = err?.response?.status
      const data = err?.response?.data
      const message =
        status ? `HTTP ${status}` :
        (err?.code === 'ECONNABORTED' ? 'Таймаут соединения' : (err?.message || 'Ошибка сети'))

      console.error('LOGIN FAILED:', { message, status, data, err })

      return {
        ok: false,
        message,
        status,
        data
      }
    }
  }

  async function refresh(refreshToken) {
    await axios
      .post(`${baseUrl}/refresh`, { refreshToken: refreshToken }, axiosConfig)
      .then((response) => {
        if (response.data.error === null) {
          this.token = response.data.accessToken
          this.refreshToken = response.data.refreshToken
          localStorage.setItem('token', JSON.stringify(response.data.accessToken))
          localStorage.setItem('refreshToken', JSON.stringify(response.data.refreshToken))
          router.push(this.returnUrl || '/')
        } else {
          console.log(response.data.error)
          router.push('/auth')
        }
      })
  }
  function logout() {
    //this.user = null
    this.token = null
    this.refreshToken = null
    //localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
    router.push('/auth')
  }
  return {
    user,
    token,
    refreshToken,
    login,
    logout
  }

})
